import { EnvironmentProviders, Provider } from '@angular/core';
import { FpLoggerNoisePicturesStore } from '@app/main/leak-detection/floating-popups/floating-popup-logger-noise/tabs/fp-logger-noise-pictures/services/fp-logger-noise-pictures/fp-logger-noise-pictures.store';
import { FpLoggerNoisePicturesConnectService } from '@app/main/leak-detection/floating-popups/floating-popup-logger-noise/tabs/fp-logger-noise-pictures/services/fp-logger-noise-pictures-connect.service';
import { FP_LOGGER_NOISE_TAB_CONNECT_SERVICES } from '@app/main/leak-detection/floating-popups/floating-popup-logger-noise/providers/fp-logger-noise-tab-connect-services.token';

export function fpLoggerNoisePicturesProvider(): (EnvironmentProviders | Provider)[] {
  return [
    FpLoggerNoisePicturesStore,
    FpLoggerNoisePicturesConnectService,
    {
      provide: FP_LOGGER_NOISE_TAB_CONNECT_SERVICES,
      useExisting: FpLoggerNoisePicturesConnectService,
      multi: true,
    },
  ];
}
